import React, { useContext, useEffect, useState } from 'react'
import { CNav, CNavItem, CNavLink, CTabContent, CTabPane } from '@coreui/react'
import { getStaticPages } from 'src/Redux/Actions/templateAction'
import { useDispatch, useSelector } from 'react-redux'
import StaticDataPage from './StaticDataPage'
import SocialLinks from './SocialLinks'
import FAQ from './FAQ'
import './staticPages.scss'
import { AppContext } from 'src/views/context/app'
import CustomStaticPage from '../customStaticPages'
import CustomPages from '../customStaticPages'

const StaticPages = () => {
  const dispatch = useDispatch()
  const { refreshData } = useSelector((state) => state.commonReducer)
  const [activeType, setActiveType] = useState('ABOUT_US')
  const { accountObj } = useContext(AppContext)
  let isCustomTemplateAllowed = accountObj?.od_resource_allowances?.custom_template

  const [aboutData, setAboutData] = useState({
    id: '',
    title: 'About us',
    type: 'ABOUT_US',
    visible: false,
    content: '',
    description:
      'It tells about what sort of company you are.  Describe about the products or services does the company, provide, and who are your clients. Your area of experties. ',
  })
  const [TNCData, setTNCData] = useState({
    id: '',
    title: 'Terms & Conditions',
    type: 'TNC',
    visible: false,
    content: '',
    description: `Your 'terms and conditions' is the contract between you and your customer for your services, and which regulates your business relationship. It set out your business procedures. It is also called as 'Business Terms', 'T & C' etc.`,
  })
  const [privacyData, setPrivacyData] = useState({
    id: '',
    title: 'Privacy Policy',
    type: 'PRIVACY_POLICY',
    visible: false,
    content: '',
    description: `A privacy policy explains how your platform will collect, store, protect, and utilize personal information provided by its users.`,
  })
  const [copyrightData, setCopyrightData] = useState({
    id: '',
    title: 'Copyright',
    type: 'COPYRIGHT',
    visible: false,
    content: '',
    description: `A Copyright policy explains how your platform will collect, store, protect, and utilize personal information provided by its users.`,
  })
  const [faqData, setFaqData] = useState({
    id: '',
    title: 'FAQs',
    type: 'FAQ',
    visible: false,
    content: [],
    description: `Provide a list of questions and answers relating to your platform, content, plans etc.`,
  })
  const [socialData, setSocialData] = useState({
    id: '',
    title: 'Social Links',
    type: 'SOCIAL_LINKS',
    visible: false,
    content: {},
  })

  useEffect(() => {
    getStaticData()
  }, [refreshData])

  const getStaticData = async () => {
    let staticRes = await dispatch(getStaticPages())
    if (staticRes?.success) {
      let { data } = staticRes
      const aboutRes = data.find((obj) => obj.type === 'ABOUT_US')
      const tncRes = data.find((obj) => obj.type === 'TNC')
      const privacyRes = data.find((obj) => obj.type === 'PRIVACY_POLICY')
      const copyRes = data.find((obj) => obj.type === 'COPYRIGHT')
      const faqRes = data.find((obj) => obj.type === 'FAQ')
      const socialRes = data.find((obj) => obj.type === 'SOCIAL_LINKS')
      setAboutData({
        ...aboutData,
        id: aboutRes._id,
        title: aboutRes.title,
        visible: aboutRes.visible_on_website,
        content: aboutRes.content,
      })
      if (tncRes) {
        setTNCData({
          ...TNCData,
          id: tncRes._id,
          title: tncRes.title,
          visible: tncRes.visible_on_website,
          content: tncRes.content,
        })
      }

      setPrivacyData({
        ...privacyData,
        id: privacyRes._id,
        title: privacyRes.title,
        visible: privacyRes.visible_on_website,
        content: privacyRes.content,
      })
      setCopyrightData({
        ...copyrightData,
        id: copyRes._id,
        title: copyRes.title,
        visible: copyRes.visible_on_website,
        content: copyRes.content,
      })
      setFaqData({
        ...faqData,
        id: faqRes._id,
        title: faqRes.title,
        visible: faqRes.visible_on_website,
        content: faqRes.content,
      })

      setSocialData({
        ...socialData,
        id: socialRes._id,
        visible: socialRes.visible_on_website,
        content: socialRes.content,
      })
    }
  }

  const activeTab = { color: '#1976d2', fontSize: '1.1rem' }
  const inActiveTab = { color: '#191818', fontSize: '1.1rem' }
  return (
    <>
      {isCustomTemplateAllowed ? (
        <CustomPages />
      ) : (
        <div className="mt-2">
          <CNav variant="tabs">
            <CNavItem>
              <CNavLink
                className="px-5"
                style={activeType === 'ABOUT_US' ? activeTab : inActiveTab}
                active={activeType === 'ABOUT_US'}
                onClick={() => setActiveType('ABOUT_US')}
              >
                About us
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                className="px-5"
                style={activeType === 'TNC' ? activeTab : inActiveTab}
                active={activeType === 'TNC'}
                onClick={() => setActiveType('TNC')}
              >
                {`Terms & Conditions`}
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                className="px-5"
                style={activeType === 'PRIVACY_POLICY' ? activeTab : inActiveTab}
                active={activeType === 'PRIVACY_POLICY'}
                onClick={() => setActiveType('PRIVACY_POLICY')}
              >
                Privacy Policy
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                className="px-5"
                style={activeType === 'COPYRIGHT' ? activeTab : inActiveTab}
                active={activeType === 'COPYRIGHT'}
                onClick={() => setActiveType('COPYRIGHT')}
              >
                Copyright
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                className="px-5"
                style={activeType === 'SOCIAL_LINKS' ? activeTab : inActiveTab}
                active={activeType === 'SOCIAL_LINKS'}
                onClick={() => setActiveType('SOCIAL_LINKS')}
              >
                Social Links
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                className="px-5"
                style={activeType === 'FAQ' ? activeTab : inActiveTab}
                active={activeType === 'FAQ'}
                onClick={() => setActiveType('FAQ')}
              >
                FAQs
              </CNavLink>
            </CNavItem>
          </CNav>
          <CTabContent>
            <CTabPane role="tabpanel" visible={activeType === 'ABOUT_US'}>
              <StaticDataPage data={aboutData} setState={setAboutData} />
            </CTabPane>
            <CTabPane role="tabpanel" visible={activeType === 'TNC'}>
              <StaticDataPage data={TNCData} setState={setTNCData} />
            </CTabPane>
            <CTabPane role="tabpanel" visible={activeType === 'PRIVACY_POLICY'}>
              <StaticDataPage data={privacyData} setState={setPrivacyData} />
            </CTabPane>
            <CTabPane role="tabpanel" visible={activeType === 'COPYRIGHT'}>
              <StaticDataPage data={copyrightData} setState={setCopyrightData} />
            </CTabPane>
            <CTabPane role="tabpanel" visible={activeType === 'SOCIAL_LINKS'}>
              <SocialLinks data={socialData} />
            </CTabPane>
            <CTabPane role="tabpanel" visible={activeType === 'FAQ'}>
              <FAQ data={faqData} />
            </CTabPane>
          </CTabContent>
        </div>
      )}
    </>
  )
}

export default StaticPages
